function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const LogoMobileZephyrIcon = (_0)=>{
    let { color = '#A873FF' } = _0, props = _object_without_properties(_0, [
        "color"
    ]);
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("g", {
                clipPath: "url(#clip0_1_4)",
                children: /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M23.6847 14.8179C23.6847 19.5551 19.7964 23.3955 14.9999 23.3955C13.1719 23.3955 11.4758 22.8377 10.0766 21.885L7.53364 24.3965C12.3331 28.0547 19.2516 27.7106 23.6524 23.3642C26.9541 20.1033 27.9748 15.4425 26.7144 11.3161C26.5114 10.6516 26.7562 9.91433 27.3648 9.56726C28.0842 9.15704 29.0108 9.45189 29.2677 10.2321C29.743 11.676 30 13.2173 30 14.8177C30 18.908 28.3218 22.6111 25.6083 25.2921C25.5871 25.3131 25.5658 25.334 25.5445 25.3548C22.8349 28.0002 19.1101 29.6336 14.999 29.6336C13.2009 29.6336 11.4767 29.3211 9.87904 28.7481C9.63041 28.6483 9.38093 28.5513 9.13065 28.457C9.08741 28.4407 9.04414 28.4244 9.00086 28.4083C7.61719 27.8927 6.2088 27.4607 4.78376 27.1124C4.0788 26.9401 3.36974 26.7883 2.65758 26.6569C1.99555 26.5348 1.72415 25.7232 2.20037 25.2529L7.84361 19.6793C6.87956 18.2975 6.31511 16.6228 6.31511 14.8179C6.31511 10.0806 10.2035 6.24033 14.9999 6.24033C16.8274 6.24033 18.5231 6.79781 19.922 7.74996L22.4645 5.23893C17.6651 1.5807 10.7465 1.9248 6.34571 6.27122C3.04374 9.53244 2.02317 14.1936 3.284 18.3203C3.48686 18.9842 3.24229 19.7208 2.63419 20.0676C1.91542 20.4774 0.989741 20.1829 0.732975 19.4033C0.257183 17.9589 4.65596e-08 16.417 0 14.8158C-1.30932e-07 10.721 1.68192 7.01426 4.40066 4.33256C7.11476 1.65548 10.8621 6.59222e-07 15.001 0C16.7991 -1.89405e-07 18.5233 0.312454 20.121 0.885385C20.3696 0.985193 20.6191 1.08226 20.8693 1.17657C20.9126 1.19287 20.9559 1.20908 20.9991 1.22521C22.3828 1.74083 23.7912 2.1728 25.2162 2.52111C25.9212 2.69343 26.6303 2.84528 27.3424 2.97665C28.0044 3.09877 28.2759 3.91037 27.7997 4.3807L22.1553 9.95533C23.1199 11.3373 23.6847 13.0124 23.6847 14.8179ZM14.8441 20.6659C18.1144 20.6659 20.7656 18.0475 20.7656 14.8176C20.7656 13.8092 20.5072 12.8605 20.0523 12.0324L12.0241 19.9614C12.8626 20.4107 13.8232 20.6659 14.8441 20.6659ZM14.8441 8.96922C11.5738 8.96922 8.92264 11.5876 8.92264 14.8176C8.92264 15.9061 9.2238 16.9253 9.74827 17.7981L17.8619 9.78467C16.9782 9.26663 15.9463 8.96922 14.8441 8.96922Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_1_4",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "30",
                        height: "30",
                        fill: "white"
                    })
                })
            })
        ]
    }));
};
